export default __webpack_public_path__ + "static/media/category-6.efe4cc36.jpg";